import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import Cookies from 'js-cookie'

import { handle401Error } from '@/app/service/util/interceptors'
import config from '@/config'

const createBaseQuery = ({ baseUrl }: { baseUrl: string }) =>
  fetchBaseQuery({
    baseUrl,
    prepareHeaders(headers) {
      const token = Cookies.get('authToken')
      const contentType = headers.get('Content-Type')
      if (contentType === 'multipart/form-data') {
        headers.delete('Content-Type') // let browser set it, including boundary
      } else if (!contentType) {
        headers.set('Content-Type', 'application/json')
      }

      if (token) {
        headers.set('Authorization', `JWT ${token}`)
      }

      return headers
    },
    async responseHandler(res) {
      // empty response statuses
      const emptyStatuses = [204, 205, 304]
      if (emptyStatuses.includes(res.status)) {
        return undefined
      }

      const contentType = res.headers.get('Content-Type')
      if (contentType?.includes('json')) {
        const json = await res.json()
        if (res.status === 401) {
          handle401Error(json)
        }
        return json
      }

      // if other content types, just return it so we can handle it outside
      return res
    },
  })

// initialize an empty api service that we'll inject endpoints into later as needed
export const esClient = createApi({
  keepUnusedDataFor: 0, // default to not keeping data around when unused, can override per endpoint as needed
  baseQuery: createBaseQuery({ baseUrl: config.svc.url || '' }),
  endpoints: () => ({}),
})
